<template>
    <NavbarAlternate/>
    <div class="general-info">
        <!-- <h2>Mazowiecki dom pogrzebowy</h2> -->
        <div class="imac-img"><img src="https://i.imgur.com/kDGP7h1.png" alt=""></div>
        <div class="project-description">
        <p>ProDeck - przy pracy nad tą stroną zajmowałem się stworzeniem wyłącznie wyglądu strony glównej na podstawie projektu graficznego przygotowanego wcześniej przez grafika.
            Główna technologia, na której został oparty ten projekt: HTML, CSS.</p>
        </div>
    </div>
    <div class="mobile-examples">
        <h4>Zobacz jak aplikacja wygląda w wersji mobilnej</h4>
        <div class="box">
            <div class="img"><img src="https://i.imgur.com/awW8grJ.png" alt=""></div>
            <div class="img"><img src="https://i.imgur.com/PjFdcis.png" alt=""></div>
            <div class="img"><img src="https://i.imgur.com/xndt1m8.png" alt=""></div>
            <div class="img"><img src="https://i.imgur.com/VzlYh1M.png" alt=""></div>
            <div class="img"><img src="https://i.imgur.com/Pg70U5o.png" alt=""></div>
            <div class="img"><img src="https://i.imgur.com/yhCwvY0.png" alt=""></div>
        </div>
    </div>

    <Footer/>
</template>

<script>
import NavbarAlternate from '../NavbarAlternate.vue'
import Footer from '../mainComponents/Footer.vue'


export default {
    name: 'Pogrzeby',
    components: {
        NavbarAlternate,
        Footer
    }
}
</script>

<style scoped  lang="scss" >

h2, h4 {
    font-family: 'Nunito', sans-serif;    
}


.general-info {
    margin-top: 8rem;

    .imac-img {
        text-align: center;
    }

    // h2 {
    //     color: #222;
    //     font-family: 'Poppins';
    //     text-align: center;
    //     font-size: 2rem;
    //     margin: 0 0 1.5rem 0;
    // }

    .project-description {
        display: flex;
        justify-content: center;

    p {
        margin: 1.5rem 0 3.5rem 0;
        width: 80%;
        text-align: justify;
        font-family: 'Poppins', sans-serif;
      
    }

    }


}

.mobile-examples {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h4 {
        margin-bottom: 2rem;
        font-size: 1.35rem;
    }

    .box {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
            width: 65%;
            // padding: 10px;
            // margin: 8px;
    }

    .img {
        text-align: center;
        flex-basis: 30%;
        padding-bottom: 1rem;
        img {
            width: 67%;
        }
    }
}


@media(max-width:768px) {
    .imac-img img {
        width: 77%;
    }
    
    .mobile-examples .box {
        width: 80%;
    }

    .box .img {
        flex-basis: 45%;
    }

    .box .img img{
        width: 80%;
    }
}

@media(max-width:425px) {
    .imac-img img {
        width: 86%;
    }

    h4 {
        text-align: center;
    }

    .box .img {
        flex-basis: 90%;
    }

}

@media(max-width:375px) {
    .box .img img{
        width: 83%;
    }
}




</style>
